import { useEffect } from "react";

/**
 * One-time cross-page reload logic for Adyen components.
 *
 * - Marks the current page as visited using `visitedKey`.
 * - If `reloadOnKey` is present in sessionStorage, clears it and reloads
 *   the page once so embedded Adyen components are fully reset.
 */
export const useAdyenPageReload = ({ visitedKey, reloadOnKey }) => {
  // Mark this page as visited
  useEffect(() => {
    if (!visitedKey) return;

    try {
      window.sessionStorage.setItem(visitedKey, "true");
    } catch {
      // Ignore storage errors (e.g. disabled storage)
    }
  }, [visitedKey]);

  // If the counterpart page was visited, reload once to reset Adyen state
  useEffect(() => {
    if (!reloadOnKey) return;

    try {
      const shouldReload =
        window.sessionStorage.getItem(reloadOnKey) === "true";

      if (shouldReload) {
        // Clear the flag before reloading so this only runs once
        window.sessionStorage.removeItem(reloadOnKey);
        window.location.reload();
      }
    } catch {
      // Ignore storage errors (e.g. disabled storage)
    }
  }, [reloadOnKey]);
};
